export const useUniformsCamera = async () => {
  const { camera } = useTresContext()
  const { onLoop } = useRenderLoop()

  const uCameraNear = { value: 0.01 }
  const uCameraFar = { value: 1000 }

  onLoop(({ elapsed }) => {
    uCameraNear.value = camera.value.near
    uCameraFar.value = camera.value.far
  })

  return { uCameraNear, uCameraFar }
}
